/**
 * LongFormModal building blocks. These are thin styled wrappers — a small
 * controlled vocabulary so every long-form modal in the app reads the same
 * way. Compose freely:
 *
 *   <LongFormModal title="Free generations" onClose={...}>
 *     <Lead>Pro and MAX include a monthly pool…</Lead>
 *     <Section title="What you get">
 *       <List items={[<><strong>Pro:</strong> 50/mo</>, <><strong>MAX:</strong> 100/mo</>]} />
 *     </Section>
 *     <Section title="Renewal">
 *       <Para>Resets at the next billing cycle.</Para>
 *     </Section>
 *   </LongFormModal>
 */

import type { ReactNode } from 'react';
import styles from './LongFormModal.module.css';

interface LeadProps {
  children: ReactNode;
}

export const Lead = ({ children }: LeadProps) => (
  <p className={styles.lead}>{children}</p>
);

interface SectionProps {
  title: string;
  children: ReactNode;
}

export const Section = ({ title, children }: SectionProps) => (
  <div className={styles.section}>
    <h4 className={styles.sectionTitle}>{title}</h4>
    {children}
  </div>
);

interface ParaProps {
  children: ReactNode;
}

export const Para = ({ children }: ParaProps) => (
  <p className={styles.para}>{children}</p>
);

interface ListProps {
  items: ReactNode[];
}

export const List = ({ items }: ListProps) => (
  <ul className={styles.list}>
    {items.map((item, i) => (
      <li key={i}>{item}</li>
    ))}
  </ul>
);
